import { gql } from '@apollo/client';

export const CREATE_SUPPORT = gql`
  mutation createSupport($input: CreateSupportInputType!) {
    createSupport(input: $input) {
      id
      supportId
      title
      description
      isClosed
      replyCount
      createdAt
    }
  }
`;

export const UPDATE_SUPPORT = gql`
  mutation updateSupport($id: String!, $input: UpdateSupportInputType!) {
    updateSupport(id: $id, input: $input) {
      id
      supportId
      title
      description
      isClosed
      createdAt
    }
  }
`;

export const CREATE_SUPPORT_REPLY = gql`
  mutation createSupportReply($supportId: String!, $input: CreateSupportReplyInputType!) {
    createSupportReply(supportId: $supportId, input: $input) {
      id
      supportId
      message
      createdAt
      user {
        id
        firstName
        lastName
      }
    }
  }
`;

/**
 * The sender comes from the token. Recipients are delivered in one batched
 * request server-side rather than one call per person.
 */
export const CREATE_MESSAGING = gql`
  mutation createMessaging($input: CreateMessagingInputType!) {
    createMessaging(input: $input) {
      id
      type
      title
      body
      recipientCount
      createdAt
    }
  }
`;

export const DELETE_MESSAGING = gql`
  mutation deleteMessaging($id: String!) {
    deleteMessaging(id: $id)
  }
`;
